import WMTSTileGrid from 'ol/tilegrid/WMTS';

/**
 * @function 生成位移uuid
 * */
export function createUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    let r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}

/**
 * @function 根据 pro 所写的 EPSG code 生成对应的 TileGrid 参数
 * */
export function getTileGrid(projection , offlevel){
  offlevel = offlevel || 0;
  if (projection === "EPSG:4326" || projection === "EPSG:4490") {
    return default4326TileGrid(offlevel);
  }
  return default3857TileGrid(offlevel);
}
/**
 * @function default4326TileGrid
 * @description 获取默认4326网格瓦片
 * @return {ol.tilegrid.WMTS} 返回默认4326网格瓦片对象
 */
function default4326TileGrid(offlevel) {
  let tdt_WGS84_resolutions = [];
  let matrixIds = [];
  for (let i = 0; i < 20; i++) {
    tdt_WGS84_resolutions.push(0.703125 / (Math.pow(2, i)));
    matrixIds.push(i + 1 + offlevel);
  }
  let tileGird = new WMTSTileGrid({
    extent: [-180, -90, 180, 90],
    resolutions: tdt_WGS84_resolutions,
    origin: [-180, 90],
    matrixIds: matrixIds,
    minZoom: 1
  });
  return tileGird;
}

/**
 * @function default3857TileGrid
 * @description 获取默认3857网格瓦片
 * @return {ol.tilegrid.WMTS} 返回默认3857网格瓦片对象
 */
function default3857TileGrid(offlevel) {
  let tdt_Mercator_resolutions = [];
  let matrixIds = [];
  for (let i = 0; i < 20; i++) {
    tdt_Mercator_resolutions.push(78271.5169640203125 / (Math.pow(2, i)));
    matrixIds.push(i + 1 + offlevel);
  }
  let tileGird = new WMTSTileGrid({
    extent: [-20037508.3427892, -20037508.3427892, 20037508.3427892, 20037508.3427892],
    resolutions: tdt_Mercator_resolutions,
    matrixIds: matrixIds,
    origin: [-20037508.3427892, 20037508.3427892],
    minZoom: 1
  });
  return tileGird;
}



// WEBPACK FOOTER //
// ./src/components/map/common/mapExt.js